<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <form @submit.prevent="submitForm">
    <p class="text-regular text-center mb-1">
      Selecione as categorias para o seu e-mail marketing
    </p>

    <b-row align-h="around">
      <b-form-group
        class="col-12 col-lg-7 text-lg-right category-fg"
        label-cols-lg="3"
        label="Categorias"
        label-for="categorias"
        label-align-lg="right"
      >
        <SearchBox
          :dataObject="activeCategoriesWithEmailMarketing"
          searchCritery="name"
          displayValue="name"
          idToSelectOptions="id"
          :isInvalid="!!errors.categories"
          placeholder="Selecione uma ou mais categorias"
          v-model="options.categories"
          class="text-left"
          :searchNameAll="'Todas as categorias'"
          @change="track(options.categories, 'Selecionou a categoria')"
        />
        <b-form-invalid-feedback
          v-if="errors.categories"
          class="d-block text-left"
          v-html="errors.categories"
        >
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        v-if="showCompliance"
        class="
          text-center
          mb-1
          col-8 col-lg-12
          email-marketing-form__rules-field
        "
      >
        <ComplianceField
          v-model="options.rulesAccepted"
          :isInvalid="!!errors.rulesAccepted"
          :rulesModalTrackLabel="`regras de divulgação_${pageAdvertiser.name}`"
        >
          <template v-slot:rules>
            <ul>
              <li>
                O Sender do disparo sempre deve ser: Produto UOL Afiliados (Ex:
                PagBank UOL Afiliados);
              </li>
              <li>
                É vetado o disparo para os seguintes destinatários:
                <ul>
                  <li>@uol.com.br</li>
                  <li>@uolinc.com</li>
                  <li>@bol.com.br</li>
                  <li>@zipmail.com.br</li>
                </ul>
              </li>
              <li>
                As peças de e-mail disponibilizadas pelo UOL Afiliados não podem
                sofrer nenhuma alteração;
              </li>
              <li>
                O assunto do disparo também não pode ser alterado. Você deve
                utilizar sempre os assuntos que a plataforma disponibiliza para
                cada peça;
              </li>
              <li>
                É obrigatória a insersão da opção Opt-out para que o
                destinatário exerça o descadastramento da base de destinatários;
              </li>
              <li>Proibida qualquer prática que possa ser vista como SPAM.</li>
            </ul>
            <p>
              Caso as regras não sejam respeitadas, sua conta poderá ser
              cancelada sem aviso prévio.
            </p>
          </template>
        </ComplianceField>
        <b-form-invalid-feedback
          v-if="errors.rulesAccepted"
          class="d-block text-center mt-0"
          v-html="errors.rulesAccepted"
        ></b-form-invalid-feedback>
      </b-form-group>

      <b-col cols="12" class="text-center mt-4" v-if="!options.showCampaigns">
        <b-button
          type="submit"
          variant="orange"
          size="lg"
          class="main-action-button"
          ref="continueBtn"
        >
          Continuar
        </b-button>
      </b-col>
    </b-row>

    <b-row align-h="around" v-if="options.showCampaigns">
      <b-form-group
        class="col-12 campaign-fg"
        label="Campanha"
        label-for="campanha"
      >
        <SearchBox
          :dataObject="campaignsFromSelectedCategories"
          searchCritery="em_description"
          displayValue="em_description"
          idToSelectOptions="em_id"
          placeholder="Selecione uma campanha"
          v-model="options.campaign"
          @change="track(options.campaign, 'Selecionou a campanha')"
        >
          <template v-slot:customView="{ rows, pickFunc }">
            <b-table
              hover
              small
              :items="rows"
              :fields="visibleColumns"
              primary-key="em_id"
              table-class="text-dark"
              thead-class="table-small-title"
              tbody-tr-class="pointer"
              @row-clicked="pickFunc($event)"
            >
              <template slot="[em_html_code]" slot-scope="data">
                <div class="text-center">
                  <b-button
                    variant="link"
                    size="sm"
                    class="align-baseline"
                    @click="
                      showPreview(data.item.em_html_code);
                      track(options.campaign, 'Viu preview do e-mail mkt');
                    "
                  >
                    <b-img
                      fluid
                      src="@/assets/preview.svg"
                      alt="Preview"
                    ></b-img>
                  </b-button>
                </div>
              </template>
            </b-table>
          </template>
        </SearchBox>
      </b-form-group>
    </b-row>

    <b-row align-h="around" v-if="options.campaign.length" class="text-dark">
      <b-form-group
        class="col-12 col-md-6"
        label="Site"
        label-for="site"
        label-class="text-dark"
        v-if="!affiliateHasPostback"
      >
        <SearchBoxSites
          v-model="options.site"
          @change="track(options.site, 'Selecionou site')"
        />
        <b-form-invalid-feedback
          v-if="errors.site"
          class="d-block"
          v-html="errors.site"
        >
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :class="[affiliateHasPostback ? 'col-12' : 'col-12 col-md-6']"
      >
        <template v-slot:label>
          <span>Identificador </span>
          <span class="sub-label"> (Opcional) </span>
          <b-img
            fluid
            src="@/assets/images/icon_info.svg"
            alt="Info"
            v-b-popover.hover.top="{
              customClass: 'custom-info-popover',
              content:
                'Nome dado para marcar uma peça gerada de acordo com a sua preferência.',
            }"
          >
          </b-img>
        </template>
        <SearchBox
          :dataObject="affiliateLabels"
          searchCritery="desLabel"
          displayValue="desLabel"
          idToSelectOptions="idtUserSupplierLabel"
          placeholder="Selecione um identificador"
          v-model="options.label"
          :radio="true"
          class="label-sb"
          :class="!affiliateInfo ? 'loading-placeholder' : ''"
          @change="track(options.label, 'Selecionou um identificador')"
        />
        <template v-slot:description>
          <b-button
            variant="link"
            size="sm"
            class="text-decoration-none info-identifier pl-0"
            @click.stop="
              toggleControls();
              track('toggleControls', 'Abriu seletor de identificadores');
              track(`configurar identificador_${pageAdvertiser.name}`);
            "
          >
            Configurar identificador
          </b-button>
        </template>
      </b-form-group>
    </b-row>

    <b-row align-h="around" v-if="showSubjectAndCode" class="text-dark">
      <b-col cols="12">
        <label for="subject-field" class="text-dark">Assunto obrigatório</label>
      </b-col>
    </b-row>

    <b-row align-h="around" v-if="showSubjectAndCode" class="text-dark subject">
      <b-col sm="12" md="10" class="text-center pr-md-0">
        <b-form-group class="position-relative mb-0">
          <b-form-input
            id="subject-field"
            class="fs-14"
            :readonly="true"
            v-model="options.subject"
            ref="subjectField"
          />
          <div
            class="
              copy-overlay
              d-flex
              align-items-center
              justify-content-center
              text-center
              subj-overlay
            "
            :class="[subjectCopied ? 'visible' : 'invisible']"
          >
            <b-img
              class="copy-img"
              src="@/assets/copy_check.svg"
              alt="Assunto copiado"
            ></b-img>
            <span class="copy-msg ml-1">Assunto copiado com sucesso</span>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        sm="12"
        md="2"
        class="text-right d-flex flex-column pl-md-1 btn-copy-subject"
      >
        <b-button
          variant="grey-shadowed fs-13 btn-res"
          @click="
            copySubject();
            track('Copiou o assunto do e-mail mkt');
            track(`copiar assunto_e-mail marketing_${pageAdvertiser.name}`);
          "
        >
          Copiar
        </b-button>
      </b-col>
    </b-row>

    <b-row align-h="around" v-if="showSubjectAndCode" class="text-dark">
      <b-col cols="12">
        <label for="code-field" class="text-dark">Código gerado</label>
      </b-col>
    </b-row>

    <b-row align-h="around" v-if="showSubjectAndCode" class="text-dark">
      <b-col sm="12" md="10" class="text-center pr-md-0">
        <b-form-group class="position-relative mb-0">
          <b-form-textarea
            id="code-field"
            class="fs-14 code-scroll"
            no-resize
            :readonly="true"
            v-model="options.code"
            rows="5"
            max-rows="5"
            ref="codeField"
            @keyup.ctrl.67="codeWasCopied"
          >
          </b-form-textarea>
          <div
            class="
              copy-overlay
              d-flex
              flex-column
              align-items-center
              justify-content-center
              text-center
              code-overlay
            "
            :class="[codeCopied ? 'visible' : 'invisible']"
          >
            <b-img
              class="copy-img"
              src="@/assets/copy_check.svg"
              alt="Assunto copiado"
            ></b-img>
            <span class="copy-msg ml-1">Código copiado com sucesso</span>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        sm="12"
        md="2"
        class="text-right d-flex flex-column pl-md-1 btn-copy-code"
      >
        <b-button
          variant="grey-shadowed flex-grow-1 fs-13 btn-res"
          @click="
            copyCode();
            track('Copiou o código do e-mail mkt');
            track(`copiar código_e-mail marketing_${pageAdvertiser.name}`);
          "
        >
          Copiar código
        </b-button>
      </b-col>

      <b-col v-if="affiliateHasPostback">
        <div class="d-flex align-items-center postback-warn mt-1">
          <b-img
            class="pr-2"
            src="@/assets/warning_icon.png"
            alt="Atenção"
          ></b-img>
          <span>Não se esqueça de substituir os parâmetros dos links</span>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="preview-modal"
      header-class="close-modal-header"
      size="lg"
      footer-class="border-0 d-flex justify-content-center pt-1"
      body-class="mr-3 custom-modal-body"
      scrollable
      centered
    >
      <span v-html="currentPreview"></span>
      <template slot="modal-footer" slot-scope="{ close }">
        <b-button
          variant="orange"
          size="lg"
          class="main-action-button"
          @click="close()"
        >
          Fechar
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import HistoryApi from '@/services/history';
import SearchBox from '@/components/SearchBox';
import ComplianceField from '@/components/ComplianceField';
import {
  generatePostbackParameters, b64EncodeUnicode,
} from '@/utils/campaignUtils';
import SearchBoxSites from '@/components/SearchBoxSites';
import { isAdvertiserCustomRules } from '@/utils/advertiserUtils';

const MASS_MAIL_SEGMENT = 'disparador de e-mail marketing';
const ROI_METER_SRC = 9;
const ROI_METER_CHN = 564;

export default {
  name: 'EmailMarketingForm',
  components: {
    SearchBox,
    ComplianceField,
    SearchBoxSites,
  },
  props: {
    presetLabel: Object,
  },
  data() {
    return {
      visibleColumns: [
        {
          key: 'em_description',
          label: 'Campanhas',
          thClass: 'no-border-bottom',
          tdClass: 'light-border-bottom',
        },
        {
          key: 'em_subject',
          label: 'Assunto',
          thClass: 'no-border-bottom',
          tdClass: 'light-border-bottom',
        },
        {
          key: 'em_html_code',
          label: 'Preview',
          thClass: 'no-border-bottom',
          tdClass: 'light-border-bottom',
        },
      ],
      advertiserId: null,
      categories: [],
      currentPreview: null,
      subjectCopied: false,
      codeCopied: false,
      options: {
        categories: [],
        rulesAccepted: false,
        showCampaigns: false,
        campaign: [],
        site: [],
        label: [],
        subject: '',
        code: '',
      },
      errors: {
        categories: null,
        rulesAccepted: null,
        campaign: null,
        site: null,
      },
    };
  },
  computed: {
    activeCategoriesWithEmailMarketing() {
      return this.categories.filter(
        c => c.active
          && c.formats
          && c.formats.length
          && c.formats.some(f => f.id === 'email_marketing'),
      );
    },
    campaignsFromSelectedCategories() {
      return this.categories
        .filter(c => this.options.categories.includes(c.id))
        .map(
          c => c.formats.filter(f => f.id === 'email_marketing')[0]
            .emails_marketing,
        )
        .reduce((acc, val) => acc.concat(val), []);
    },
    affiliateHasPostback() {
      try {
        return Object.keys(this.affiliateInfo.postbackConfig).length > 0;
      } catch {
        return false;
      }
    },
    showSubjectAndCode() {
      return (
        this.options.campaign.length
        && (this.affiliateHasPostback || this.options.site.length)
      );
    },
    ...mapGetters([
      'approvedUrls',
      'affiliateLabels',
      'affiliateInfo',
      'pageAdvertiser',
      'approvedUrlsByIdt',
    ]),
    showCompliance() {
      if (!this.advertiserId) return false;
      return isAdvertiserCustomRules(this.advertiserId);
      
    },
  },
  methods: {
    splitCharsByLimit(content, maxLength = 32000, manupilator = () => {}) {
      let initial = 0;
      let final = maxLength;
      const splitedContent = [];
      let currentResult;

      // eslint-disable-next-line no-cond-assign
      while (currentResult = content.substring(initial, final)) {
        initial += maxLength;
        final += maxLength;
        splitedContent.push(manupilator(currentResult) || currentResult);
      }

      return splitedContent;
    },
    escapeDatabaseChars(str) {
      return str.replace(/'/g, "' || chr(39) || '")
        .replace(/&/g, "' || chr(38)|| '")
        .replace(/=/g, "' || chr(61) || '");
    },
    codeWasCopied() {
      this.copyCode();
    },
    validateForm() {
      let isValid = true;

      if (this.options.categories.length === 0) {
        this.errors.categories = 'Selecione as <strong>categorias</strong>';
        isValid = false;
      }

      if (!this.options.rulesAccepted && this.showCompliance) {
        this.errors.rulesAccepted = 'Por favor leia e aceite as <strong>Regras de Divulgação</strong>';
        isValid = false;
      }
      return isValid;
    },
    showPreview(htmlCode) {
      this.currentPreview = htmlCode;
      this.$bvModal.show('preview-modal');
    },
    submitForm() {
      if (this.validateForm()) {
        this.options.showCampaigns = true;
      }
    },
    clearFormFields() {
      this.options.campaign = [];
      this.options.site = [];
      this.clearCopyFlags();
      this.clearGeneratedFields();
    },
    clearGeneratedFields() {
      this.options.subject = '';
      this.options.code = '';
    },
    clearCopyFlags() {
      this.subjectCopied = false;
      this.codeCopied = false;
    },
    buildEmailMarketingOutput() {
      this.clearCopyFlags();
      if (
        this.options.campaign
        && (this.affiliateHasPostback || this.options.site.length)
      ) {
        const currentCampaign = this.campaignsFromSelectedCategories.filter(
          c => c.em_id === this.options.campaign[0],
        );
        if (currentCampaign.length) {
          this.options.subject = currentCampaign[0].em_subject;
          this.options.code = this.buildCodeOutput(currentCampaign[0]);
        }
      } else {
        this.clearGeneratedFields();
      }
    },
    buildCodeOutput(currentCampaign) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        currentCampaign.em_html_code,
        'text/html',
      );
      const links = doc.querySelectorAll('a:not([keeplink])');
      const url = new URL('https://click.afiliados.uol.com.br/Clique');

      const isMassMailSender = this.affiliateInfo.segmentList.some(
        s => s.desAffSegment.toLowerCase() === MASS_MAIL_SEGMENT,
      );

      if (this.affiliateHasPostback) {
        url.searchParams.append(
          'parameters',
          generatePostbackParameters(
            this.advertiserId,
            this.affiliateInfo.postbackConfig,
          ),
        );
        url.searchParams.append(
          'cpg',
          btoa(this.affiliateInfo.codDisplaySupplier),
        );
      } else {
        url.searchParams.append('cpg', btoa(this.options.site[0]));
        url.searchParams.append('idtUrl', this.options.site[0]);
      }

      if (this.options.label.length) {
        url.searchParams.append('idtLabel', this.options.label[0]);
      }

      url.searchParams.append('source', this.advertiserId);
      url.searchParams.append('caf', this.affiliateInfo.codDisplaySupplier);
      url.searchParams.append('type', 'email_marketing');
      url.searchParams.append('idtEmarketing', currentCampaign.em_id);
      url.searchParams.append('creative', b64EncodeUnicode(currentCampaign.em_description));

      let redirect;
      links.forEach(async (l) => {
        redirect = l.href;
        redirect += `${redirect.match(/\?/) ? '&' : '?'}aff_source=${
          this.affiliateInfo.codDisplaySupplier
        }`;
        if (isMassMailSender) {
          redirect += `&disp=true&grp=src:${ROI_METER_SRC};chn:${ROI_METER_CHN}`;
        }
        // eslint-disable-next-line no-param-reassign
        l.href = `${decodeURIComponent(
          url.toString(),
        )}&affRedir=${encodeURIComponent(redirect)}`;
      });
      return this.decodeHtmlCorrectly(doc.documentElement.outerHTML);
    },
    decodeHtmlCorrectly(html) {
      const tempTextArea = document.createElement('textarea');
      tempTextArea.innerHTML = html;
      const decodedHtml = tempTextArea.value;
      tempTextArea.remove();
      return decodedHtml;
    },
    copySubject() {
      this.$refs.subjectField.select();
      window.document.execCommand('copy');
      this.$refs.subjectField.setSelectionRange(0, 0);
      this.$refs.subjectField.blur();
      this.codeCopied = false;
      this.subjectCopied = true;
      this.clearCopyDivs();
    },
    copyCode() {
      this.$refs.codeField.select();
      window.document.execCommand('copy');
      this.$refs.codeField.setSelectionRange(0, 0);
      this.$refs.codeField.blur();
      this.subjectCopied = false;
      this.codeCopied = true;
      this.saveFormatHistory();
      this.clearCopyDivs();
    },
    clearCopyDivs() {
      setTimeout(() => {
        this.subjectCopied = false;
        this.codeCopied = false;
      }, 5000);
    },
    async saveFormatHistory() {
      const codeFinal = this.splitCharsByLimit(
        this.escapeDatabaseChars(this.options.code),
        32000,
        chars => chars,
      );

      const payload = {
        idtPerson: this.affiliateInfo.idtPerson,
        idtProductSource: this.advertiserId, // this.options.advertiser[0],
        idtFormat: this.options.campaign[0], // this.options.categories[0], // idt da Campanha
        format: 'E-mail marketing',
        category: this.getCategoryDescription(),
        description: this.campaignsFromSelectedCategories

          .filter(category => category.em_id === this.options.campaign[0])
          .map(category => category.em_description)[0],
        content: codeFinal.join(' || '),
        label: this.affiliateLabels
          .filter(
            label => label.idtUserSupplierLabel === this.options.label[0],
          )
          .map(label => label.desLabel)[0],
        site: this.approvedUrlsByIdt
          .filter(site => site.idtUserSupplierUrl === this.options.site[0])
          .map(site => site.desUrl)[0],
      };
      await HistoryApi.insertHistory(payload);
    },
    getCategoryDescription() {
      const foundActiveCategory = this.activeCategoriesWithEmailMarketing.find(
        (activeCategory) => {
          const foundFormat = activeCategory.formats.find((format) => {
            if (format.id === 'email_marketing') {
              const foundEmailMarketing = format.emails_marketing.find(
                (emailMarketing) => {
                  if (emailMarketing.em_id === this.options.campaign[0]) {
                    return true;
                  }
                  return false;
                },
              );

              if (
                foundEmailMarketing !== null
                && foundEmailMarketing !== undefined
              ) {
                return true;
              }
              return false;
            }
            return false;
          });

          if (foundFormat !== null && foundFormat !== undefined) {
            return true;
          }
          return false;
        },
      );

      if (foundActiveCategory !== null && foundActiveCategory !== undefined) {
        return foundActiveCategory.name;
      }
      return '';
    },
  },
  async created() {
    const { pageAdvertiser } = this;
    this.advertiserId = pageAdvertiser.id;
    this.categories = pageAdvertiser.campaigns;
  },
  watch: {
    'options.categories': {
      handler() {
        this.errors.categories = null;
        this.options.campaign = [];
        if (!this.options.categories.length) {
          this.options.showCampaigns = false;
        }
        this.clearFormFields();
      },
    },
    'options.rulesAccepted': {
      handler() {
        this.errors.rulesAccepted = null;
        this.options.campaign = [];
        if (!this.options.rulesAccepted) {
          this.options.showCampaigns = false;
        }
        this.clearFormFields();
      },
    },
    'options.campaign': 'buildEmailMarketingOutput',
    'options.site': 'buildEmailMarketingOutput',
    presetLabel: {
      immediate: true,
      handler(label) {
        if (label) {
          this.options.label = [label.idtUserSupplierLabel];
        }
      },
    },
    'options.label': {
      handler(selectedLabels) {
        this.buildEmailMarketingOutput();
        const selectedLabel = this.affiliateLabels.find(label => selectedLabels.includes(label.idtUserSupplierLabel));
        this.$emit('labelUpdated', selectedLabel);
      },
    },
  },
  inject: ['toggleControls'],
};
</script>

<style lang="scss" scoped>
/deep/ {
  .select {
    font-size: 14px;
  }
  .search {
    font-size: 14px;
    color: $boulder;
  }
  .no-border-bottom {
    border-bottom: none;
  }
  .light-border-bottom {
    border-top: none;
    border-bottom: 1px solid $silver;
  }
}
.link {
  padding: 0;
  border: 0;
  color: $denim;
}
.sub-label {
  font-size: 12px;
  color: $dove-gray-2;
}
.info-identifier {
  font-size: 14px;
  color: $denim;
}
.subject {
  margin-bottom: 16px;
}
.fs-13 {
  font-size: 13px;
}
.fs-14 {
  font-size: 14px;
}
.code-scroll {
  &::-webkit-scrollbar {
    width: 15px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 40%;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: $gray;
    background-clip: padding-box;
    border: 2px solid white;
    border-right-width: 5px;
    border-left-width: 5px;
    border-radius: 40%;
  }
}

@media screen and (max-width: $md - 1px) {
  .btn-res {
    line-height: 2.25;
  }
}
</style>
